import { render, staticRenderFns } from "./collectorImportdata.vue?vue&type=template&id=2e8e2d4c&"
import script from "./collectorImportdata.vue?vue&type=script&lang=ts&"
export * from "./collectorImportdata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "collectorImportdata.vue"
export default component.exports